/* PURE LAB — behaviour written for this store. Loaded as a classic script, deferred. */

/* ============================================================
   Mega menu: nested submenu toggles
   ============================================================ */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.mega-submenu-toggle');
    if(!btn) return;
    e.preventDefault();
    var wrap = btn.nextElementSibling;
    if(!wrap || !wrap.classList.contains('mega-submenu-wrap')) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    wrap.classList.toggle('is-open', !open);
  });
})();

/* ============================================================
   Account dialog
   ============================================================ */
  (function () {
    var dialog = document.getElementById('account-dialog');
    if (!dialog) return;

    var triggers = document.querySelectorAll('[data-account-open]');
    var panel = dialog.querySelector('.account-dialog__panel');
    var form = dialog.querySelector('[data-account-form]');
    var input = dialog.querySelector('#account-dialog-email');
    var submit = dialog.querySelector('.account-dialog__submit');
    var lastTrigger = null;
    var closeTimer = null;

    function openDialog(trigger) {
      lastTrigger = trigger || null;
      clearTimeout(closeTimer);
      dialog.hidden = false;
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      requestAnimationFrame(function () { dialog.classList.add('is-open'); });
      setTimeout(function () { input && input.focus(); }, 120);
    }

    function closeDialog() {
      dialog.classList.remove('is-open');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      closeTimer = setTimeout(function () { dialog.hidden = true; }, 220);
      if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (dialog.hidden) openDialog(trigger); else closeDialog();
      });
    });

    dialog.querySelectorAll('[data-account-close]').forEach(function (el) {
      el.addEventListener('click', closeDialog);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) closeDialog();
    });

    if (input && submit) {
      input.addEventListener('input', function () {
        submit.disabled = input.value.trim().length === 0;
      });
    }

    /* The form used to swallow its own submit, so the arrow did nothing at all. It now
       carries the address typed here over to Shopify's login page. */
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = input ? input.value.trim() : '';
        var target = form.getAttribute('action') || '/account/login';
        if (email) {
          target += (target.indexOf('?') === -1 ? '?' : '&') + 'email=' + encodeURIComponent(email);
        }

        if (submit) submit.disabled = true;
        window.location.href = target;
      });
    }

    if (panel) {
      panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var focusable = panel.querySelectorAll('button, input, a[href]');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
  })();

/* ============================================================
   Newsletter popup
   ============================================================ */
(function(){
  var overlay = document.getElementById('nlp-overlay');
  var closeBtn = document.getElementById('nlp-close');
  var skip = document.getElementById('nlp-skip');
  var form = document.getElementById('nlp-form');
  if (!overlay || !closeBtn) return;

  var KEY = 'purelab:newsletter';
  var DAY = 86400000;
  var SUBSCRIBED_DAYS = 365;

  // An answer is kept with its own expiry, so the popup can come back eventually
  // without ever nagging someone who has just closed it — or signed up.
  function remember(days){
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + days * DAY }));
    } catch(e){ /* private mode: the popup behaves as it always did */ }
  }

  function answered(){
    try {
      var stored = JSON.parse(window.localStorage.getItem(KEY));
      return !!stored && stored.until > Date.now();
    } catch(e){ return false; }
  }

  function open(){ overlay.classList.add('open'); overlay.setAttribute('aria-hidden','false'); }
  function close(){ overlay.classList.remove('open'); overlay.setAttribute('aria-hidden','true'); }

  var dismissDays = parseFloat(overlay.getAttribute('data-remember-days')) || 14;
  function dismiss(){ close(); remember(dismissDays); }

  closeBtn.addEventListener('click', dismiss);
  if (skip) skip.addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) dismiss(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && overlay.classList.contains('open')) dismiss(); });
  if (form) form.addEventListener('submit', function(){ remember(SUBSCRIBED_DAYS); });

  // The form reloads the page, so the confirmation arrives as a fresh render: show it
  // once, whatever the delay, and do not ask this visitor again for a year.
  if (overlay.querySelector('[data-nlp-subscribed]')) {
    remember(SUBSCRIBED_DAYS);
    open();
    return;
  }

  // The customizer always shows it, otherwise the merchant could not edit it.
  var designMode = window.Shopify && window.Shopify.designMode;
  if (answered() && !designMode) return;

  var delay = (parseFloat(overlay.getAttribute('data-delay')) || 2) * 1000;
  setTimeout(open, delay);
})();

/* ============================================================
   Membership popup
   ============================================================ */
(function(){
  var launcher = document.getElementById('mbr-launcher');
  var pop      = document.getElementById('mbr-pop');
  var closeBtn = document.getElementById('mbr-close');
  if (!launcher || !pop || !closeBtn) return;
  function open(){ pop.classList.add('open'); launcher.classList.add('is-open'); document.documentElement.classList.add('mbr-open'); pop.setAttribute('aria-hidden','false'); }
  function close(){ pop.classList.remove('open'); launcher.classList.remove('is-open'); document.documentElement.classList.remove('mbr-open'); pop.setAttribute('aria-hidden','true'); }
  launcher.addEventListener('click', function(e){ e.stopPropagation(); pop.classList.contains('open') ? close() : open(); });
  closeBtn.addEventListener('click', close);
  pop.addEventListener('click', function(e){ e.stopPropagation(); });
  document.addEventListener('click', function(){ if(pop.classList.contains('open')) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();

/* ============================================================
   Brush headline reveal
   ============================================================ */
(function(){
  var els = document.querySelectorAll('.brush-anim');
  if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('brush-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('brush-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.45 });
  els.forEach(function(e){ io.observe(e); });
})();

/* The prototype rebuilt the description into accordions of its own, splitting it on
   its headings and emptying the container first. The description is one plain block
   now, with nothing to split on, so that script only ever wiped it. */

/* ============================================================
   Product page: accordions + sticky buy bar
   ============================================================ */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.pdp-accordion__header');
    if(!btn) return;
    var wrap = btn.nextElementSibling;
    if(!wrap || !wrap.classList.contains('pdp-accordion__wrap')) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    wrap.classList.toggle('is-open', !open);
  });

  var bar = document.getElementById('pdp-sticky');
  var anchor = document.querySelector('.buy-buttons');
  if(!bar || !anchor || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
  }, { threshold: 0 });
  io.observe(anchor);
})();

/* ============================================================
   Collection: infinite scroll
   ============================================================ */
(function(){
  var sentinel = document.getElementById('infinite-scroll-sentinel');
  var grid = document.getElementById('product-grid');

  /* The toolbar reports how many products are on screen, not how many the first
     page held, so it has to be recounted after every batch. */
  function updateProductCount(){
    var label = document.querySelector('[data-product-count]');
    if(!label || !grid) return;

    var template = label.getAttribute('data-template');
    if(!template) return;

    label.textContent = template
      .replace('__COUNT__', grid.children.length)
      .replace('__TOTAL__', label.getAttribute('data-total'));
  }
  var loading = document.getElementById('infinite-scroll-loading');
  var paginationNav = document.getElementById('pagination-nav');
  if(!sentinel || !grid) return;

  var isLoading = false;

  function loadNext(){
    var nextUrl = sentinel.getAttribute('data-next');
    if(!nextUrl || isLoading) return;
    isLoading = true;
    if(loading) loading.hidden = false;

    fetch(nextUrl)
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        var nextSentinel = doc.getElementById('infinite-scroll-sentinel');

        if(nextGrid){
          [].slice.call(nextGrid.children).forEach(function(card, i){
            card.classList.add('product-card--infinite-in');
            card.style.animationDelay = (i * 40) + 'ms';
            grid.appendChild(card);
          });

          updateProductCount();
        }

        // chain to whatever page comes after the one we just merged in, so page 3, 4... would keep working too
        var followingUrl = nextSentinel ? nextSentinel.getAttribute('data-next') : '';
        sentinel.setAttribute('data-next', followingUrl || '');
        if(!followingUrl){
          io.disconnect();
          sentinel.remove();
        }
      })
      .catch(function(){
        // fail quietly; the (hidden) pagination links still work as a manual fallback
      })
      .finally(function(){
        isLoading = false;
        if(loading) loading.hidden = true;
      });
  }

  // hide pagination only when there's actually a next page for infinite scroll to chain into;
  // on the last page, leave it visible so it still works as a way back
  if(paginationNav && sentinel.getAttribute('data-next')) paginationNav.style.display = 'none';

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){ if(entry.isIntersecting) loadNext(); });
  }, { rootMargin: '150px 0px 0px 0px' });

  io.observe(sentinel);
})();

/* ============================================================
   Featured collections: tab switching
   ============================================================ */
(function () {
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-collection-tabs] [role="tab"]');
    if (!tab) return;

    var list = tab.closest('[data-collection-tabs]');
    var section = list.closest('.shopify-section') || document;

    list.querySelectorAll('[role="tab"]').forEach(function (node) {
      node.setAttribute('aria-selected', String(node === tab));
    });

    var target = tab.getAttribute('aria-controls');
    section.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      panel.hidden = panel.id !== target;
    });
  });
})();

/* ============================================================
   Product page: keep the submitted variant id in sync
   The theme's <variant-picker> re-renders the section; this only guarantees the
   hidden id field matches the checked options, so add to cart is never wrong.
   ============================================================ */
(function () {
  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  var formId = picker.getAttribute('form-id');
  var form = document.getElementById(formId);
  var idField = form && form.querySelector('[data-variant-id]');
  var source = picker.querySelector('script[data-variants]');
  if (!form || !idField || !source) return;

  var variants;
  try {
    variants = JSON.parse(source.textContent);
  } catch (error) {
    return;
  }

  function selectedOptions() {
    return Array.prototype.map.call(
      picker.querySelectorAll('input[data-option-position]:checked'),
      function (input) {
        return input.value;
      }
    );
  }

  function sync() {
    var chosen = selectedOptions();

    var match = variants.filter(function (candidate) {
      return chosen.every(function (value, index) {
        return candidate.options[index] === value;
      });
    })[0];

    if (!match) return;

    idField.value = match.id;

    var submit = form.querySelector('button[type="submit"]');
    if (submit) submit.disabled = match.available === false;
  }

  picker.addEventListener('change', function (event) {
    if (event.target.matches('input[data-option-position]')) sync();
  });

  sync();
})();


/* ============================================================
   Notice panel: the bell keeps a dot until this set of notices has been opened
   ============================================================ */
(function () {
  var panel = document.getElementById('news-modal');
  var dot = document.querySelector('[data-news-dot]');
  var signatureNode = document.querySelector('[data-news-signature]');
  if (!panel || !dot || !signatureNode) return;

  var signature;
  try {
    signature = JSON.parse(signatureNode.textContent);
  } catch (error) {
    return;
  }

  var KEY = 'purelab:news-seen';
  var seen = null;
  try {
    seen = window.localStorage.getItem(KEY);
  } catch (error) {
    /* private mode: the dot simply shows every visit */
  }

  dot.hidden = seen === signature;

  panel.addEventListener('dialog:after-show', function () {
    dot.hidden = true;
    try {
      window.localStorage.setItem(KEY, signature);
    } catch (error) {}
  });
})();
